/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { MainContainer } from "./Country.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";
import {
  countryflagIcons as flagIcons,
  defaultCountryFlag,
} from "@utils/country-data";

const Country = (props) => {
  const { t, data } = props;
  return (
    <>
      <DivBackgroundOpacity opacity={data.status ? "1" : "0.2"}>
        <MainContainer>
          {data?.countryInfo?.id && (
            <Image
              src={
                flagIcons[data.countryInfo.id]
                  ? flagIcons[data.countryInfo.id]
                  : defaultCountryFlag
              }
              alt="Avatar"
              title={t(data.countryInfo.name)}
              styles={{ width: "40px" }}
            />
          )}
        </MainContainer>
      </DivBackgroundOpacity>
    </>
  );
};

Country.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

Country.defaultProps = {
  page: null,
};

export default withTranslation()(Country);
